import { getDefaultBlogDesign } from '@/configs/defaultBlogDesign';
import { Link } from 'react-router-dom';

import { AddToFavorites } from '@/components/Shared/AddToFavorites';
import { BlogDisplayStyled } from '@/components/Shared/BlogDisplay.style';
import { useTokenState } from '@/store/localStorage/useTokenState';
import { useTheme } from '@/features/theme';

function BlogDisplay({ profile, design }) {
  const [token] = useTokenState();
  const isUserLoggedIn = Boolean(token);
  const { mode } = useTheme();

  return (
    <BlogDisplayStyled design={design ?? getDefaultBlogDesign(mode)}>
      <Link
        className="blog-title"
        to={`/blog/${profile.blogSlug}`}
        title="блог"
      >
        {profile.blogTitle}
      </Link>
      {isUserLoggedIn && <AddToFavorites profile={profile} />}
    </BlogDisplayStyled>
  );
}

export default BlogDisplay;
